var map = {
	"./MusicConfig": "f1d2",
	"./MusicConfig.js": "f1d2",
	"./images/bcgSongs_zaiks.png": "2681",
	"./images/checkbox.jpg": "7c48",
	"./images/checkboxfill.jpg": "cb85",
	"./images/musictmp.jpg": "ab2c",
	"./images/nagraniaBackground.jpg": "17cf",
	"./images/nagraniaBackground.webp": "6305",
	"./musics/5. Zabawy z mama i tata.mp3": "4a9f",
	"./musics/cd1/Track_10_It_s Blue_.mp3": "9de5",
	"./musics/cd1/Track_11_Story_2_Colours.mp3": "bb48",
	"./musics/cd1/Track_12_Yika yika.mp3": "6baf",
	"./musics/cd1/Track_13_My Emotions.mp3": "5193",
	"./musics/cd1/Track_14_Story_3_I_m hungry_.mp3": "b317",
	"./musics/cd1/Track_15_How Are You.mp3": "32e7",
	"./musics/cd1/Track_16_It_s My Mummy.mp3": "b43f",
	"./musics/cd1/Track_17_Story_4_Help me_.mp3": "8f13",
	"./musics/cd1/Track_18_Yoo-hoo.mp3": "1727",
	"./musics/cd1/Track_19_My Toys.mp3": "f7d4",
	"./musics/cd1/Track_1_Fun Time.mp3": "0602",
	"./musics/cd1/Track_20_Story_5_My cars.mp3": "f96d",
	"./musics/cd1/Track_21_One, Two, Three.mp3": "7797",
	"./musics/cd1/Track_22_Clap_Clap_Clap.mp3": "8f27",
	"./musics/cd1/Track_23_Story_6_Talent_show.mp3": "557a",
	"./musics/cd1/Track_24_Catch_the_Ball.mp3": "7ca0",
	"./musics/cd1/Track_25_It_s_a_Pear.mp3": "948d",
	"./musics/cd1/Track_26_Story_7_Picnic.mp3": "fecd",
	"./musics/cd1/Track_27_A_Pepper_Is_Green.mp3": "bd5a",
	"./musics/cd1/Track_28_What_Is_It.mp3": "38ac",
	"./musics/cd1/Track_29_Story_8_I_Love_Pets.mp3": "bef7",
	"./musics/cd1/Track_2_Hello_.mp3": "f7d7",
	"./musics/cd1/Track_30_Hey_Hey.mp3": "b7dc",
	"./musics/cd1/Track_31_I_ve_Got_One_Head.mp3": "127a",
	"./musics/cd1/Track_32_Story_9_Let_s_Dance.mp3": "a4d7",
	"./musics/cd1/Track_33_Look_at_Me.mp3": "b1b0",
	"./musics/cd1/Track_34_A_Yellow_hat.mp3": "275e",
	"./musics/cd1/Track_35_Story_10_Fashion_show.mp3": "9584",
	"./musics/cd1/Track_36_Yes_You.mp3": "bea2",
	"./musics/cd1/Track_37_Baubles_Bells.mp3": "1499",
	"./musics/cd1/Track_38_Carnival_Dance.mp3": "aa42",
	"./musics/cd1/Track_39_My_Pizza.mp3": "0dcf",
	"./musics/cd1/Track_3_Bye-bye Song.mp3": "3ab7",
	"./musics/cd1/Track_40_Easter_Is_Fun.mp3": "c749",
	"./musics/cd1/Track_41_Slowniczek_Unit_1.mp3": "a3fa",
	"./musics/cd1/Track_42_Słowniczek_Unit_2.mp3": "97eb",
	"./musics/cd1/Track_43_Slowniczek_Unit_3.mp3": "a4a3",
	"./musics/cd1/Track_44_Slowniczek_Unit_4.mp3": "f612",
	"./musics/cd1/Track_45_Slowniczek_Unit_5.mp3": "68ab",
	"./musics/cd1/Track_46_Slowniczek_Unit_6.mp3": "1531",
	"./musics/cd1/Track_47_Slowniczek_Unit_7.mp3": "067d",
	"./musics/cd1/Track_48_Slowniczek_Unit_8.mp3": "5b00",
	"./musics/cd1/Track_49_Slowniczek_Unit_9.mp3": "5caa",
	"./musics/cd1/Track_4_Fun Time Rhyme.mp3": "5f03",
	"./musics/cd1/Track_50_Slowniczek_Unit_10.mp3": "44e4",
	"./musics/cd1/Track_5_Table Time Rhyme.mp3": "6d54",
	"./musics/cd1/Track_6_Let_s Move_.mp3": "7401",
	"./musics/cd1/Track_7_I_m Dusty_.mp3": "a8af",
	"./musics/cd1/Track_8_Story_1_Hello Lisa_.mp3": "eecf",
	"./musics/cd1/Track_9_Look_.mp3": "549a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e54";